// Loads the Google Maps JS API (Places library) exactly once.
let promise = null;

export function loadGoogleMaps() {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve(window.google);
  }
  if (promise) return promise;

  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  promise = new Promise((resolve, reject) => {
    if (!key) {
      reject(new Error('Missing Google Maps API key'));
      return;
    }
    const existing = document.getElementById('google-maps-script');
    if (existing) {
      existing.addEventListener('load', () => resolve(window.google));
      existing.addEventListener('error', reject);
      return;
    }
    const s = document.createElement('script');
    s.id = 'google-maps-script';
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=de&region=CH`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(window.google);
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return promise;
}
